import { gql } from '@apollo/client'

export default gql(`
    mutation updateOfferAttribute($input: [UpdateOfferAttributeInput], $partnerId: ID  $project: String) {
        updateOfferAttribute(
            input: $input,
            partnerId: $partnerId
            project: $project
        ){
            id
        }
    }`
)
